import { ArticleImageTitle } from './ArticleImageTitle'

export default ArticleImageTitle
